"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RoomInput = function RoomInput(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      info = _ref.info,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      onInputChange = _ref.onInputChange,
      className = _ref.className,
      otherProps = _ref.otherProps,
      value = _ref.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = (0, _react.useState)(value === minValue),
      _useState6 = _slicedToArray(_useState5, 2),
      wasMinReached = _useState6[0],
      setWasMinReached = _useState6[1];

  var _useState7 = (0, _react.useState)(value === maxValue),
      _useState8 = _slicedToArray(_useState7, 2),
      wasMaxReached = _useState8[0],
      setWasMaxReached = _useState8[1];

  var initialRender = (0, _react.useRef)(true);
  /* Life cycles
  -------------------------------------------------- */

  (0, _react.useEffect)(function () {
    /** Pass back the current value of the input */
    // Avoid initialRender onChange call (can cause bugs in ProFlow)
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      onInputChange(inputValue);
    }
  }, [inputValue]);
  (0, _react.useEffect)(function () {
    setWasMinReached(value <= minValue);
    setWasMaxReached(value >= maxValue);
    setInputValue(value);
  }, [value]);
  /* Event handling
  -------------------------------------------------- */

  var handleInfoClick = function handleInfoClick() {
    setShowInfo(!showInfo);
  };
  /**
   * Function that handles the clicking of the buttons aside the input.
   * @param {string} action Defines wether the button clicked was minus or plus.
   */


  var handleInputButtonClick = function handleInputButtonClick(action) {
    setWasMaxReached(false);
    setWasMinReached(false);

    if (action === 'minus') {
      if (inputValue > minValue) {
        setInputValue(inputValue - 1);

        if (inputValue - 1 === minValue) {
          setWasMinReached(true);
        }
      } else {
        setWasMinReached(true);
      }
    } else if (action === 'plus') {
      if (maxValue) {
        if (inputValue < maxValue) {
          setInputValue(inputValue + 1);

          if (inputValue + 1 === maxValue) {
            setWasMaxReached(true);
          }
        } else {
          setWasMaxReached(true);
        }
      } else {
        setInputValue(inputValue + 1);
      }
    }
  };
  /**
   * Function that handles the changing of the input directly.
   * @param {string} val Value passed from input
   */


  var handleInputChange = function handleInputChange(val) {
    if (isNaN(val) || val === '') {
      if (val === '') {
        setInputValue(minValue);
        setWasMinReached(true);
      }
    } else {
      setWasMaxReached(false);
      setWasMinReached(false);

      if (parseInt(val) > minValue) {
        setInputValue(parseInt(val));

        if (maxValue) {
          if (parseInt(val) < maxValue) {
            setInputValue(parseInt(val));
          } else {
            setInputValue(maxValue);
            setWasMaxReached(true);
          }
        } else {
          setInputValue(parseInt(val));
        }
      } else {
        setWasMinReached(true);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(RoomInputWrapper, _extends({
    className: className
  }, otherProps), icon ? /*#__PURE__*/_react.default.createElement(IconWrapper, null, icon) : null, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    icon: icon
  }, /*#__PURE__*/_react.default.createElement(ContentHeader, null, /*#__PURE__*/_react.default.createElement(Label, null, label), info ? /*#__PURE__*/_react.default.createElement(InfoButton, {
    onClick: function onClick() {
      handleInfoClick();
    }
  }, "? ", /*#__PURE__*/_react.default.createElement(InfoTooltip, {
    active: showInfo
  }, info)) : null), /*#__PURE__*/_react.default.createElement(InputWrapper, null, /*#__PURE__*/_react.default.createElement(InputButton, {
    minus: true,
    disabled: wasMinReached,
    onClick: function onClick() {
      handleInputButtonClick('minus');
    }
  }, "-"), /*#__PURE__*/_react.default.createElement(Input, {
    value: inputValue,
    onChange: function onChange(event) {
      handleInputChange(event.currentTarget.value);
    }
  }), /*#__PURE__*/_react.default.createElement(InputButton, {
    plus: true,
    disabled: wasMaxReached,
    onClick: function onClick() {
      handleInputButtonClick('plus');
    }
  }, "+"))));
};

var RoomInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomInputWrapper"
})(["width:100%;max-width:100rem;background-color:white;border:1px solid #f0f1f3;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);border-radius:0.5rem;display:flex;justify-content:flex-start;"]);

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconWrapper"
})(["flex:0 0 33.33%;padding:1.6rem;display:flex;justify-content:center;align-items:center;border-right:2px solid #f0f1f3;> svg path{fill:#e4e4e4;}"]);

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "ContentWrapper"
})(["flex:", ";padding:1.6rem;display:flex;flex-flow:column;justify-content:flex-start;align-items:flex-start;"], function (_ref2) {
  var icon = _ref2.icon;
  return icon ? '0 0 66.66%' : '0 0 100%';
});

var ContentHeader = _styledComponents.default.div.withConfig({
  displayName: "ContentHeader"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;margin-bottom:0.8rem;"]);

var Label = _styledComponents.default.div.withConfig({
  displayName: "Label"
})(["font-family:", ";font-size:1.4rem;line-height:120%;color:#8990a3;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

var InfoButton = _styledComponents.default.div.withConfig({
  displayName: "InfoButton"
})(["width:2rem;height:2rem;border-radius:9999px;font-family:", ";font-size:1.2rem;line-height:120%;color:#8990a3;border:2px solid #8990a3;display:flex;justify-content:center;align-items:center;cursor:pointer;position:relative;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
});

var InfoTooltip = _styledComponents.default.div.withConfig({
  displayName: "InfoTooltip"
})(["position:absolute;bottom:2.8rem;width:300px;background-color:#222;border-radius:5px;padding:0.8rem;color:white;display:", ";&::after,&::before{top:100%;left:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&::after{border-color:transparent;border-top-color:#222;border-width:6px;margin-left:-6px;}"], function (_ref5) {
  var active = _ref5.active;
  return active ? 'block' : 'none';
});

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "InputWrapper"
})(["display:flex;width:100%;height:4rem;font-family:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.font;
});

var InputButton = _styledComponents.default.div.withConfig({
  displayName: "InputButton"
})(["flex:0 0 38px;border-radius:", ";border:2px solid #f0f1f3;display:flex;justify-content:center;align-items:center;font-size:2.4rem;line-height:120%;padding-bottom:3px;cursor:", ";border-right:", ";border-left:", ";color:", ";user-select:none;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,color 0.15s ease-in-out;&:hover{background-color:", ";border-color:", ";color:", ";}"], function (_ref7) {
  var minus = _ref7.minus,
      plus = _ref7.plus;
  return minus ? '9999px 0 0 9999px' : plus ? '0 9999px 9999px 0' : null;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref9) {
  var minus = _ref9.minus;
  return minus ? '0' : null;
}, function (_ref10) {
  var plus = _ref10.plus;
  return plus ? '0' : null;
}, function (_ref11) {
  var disabled = _ref11.disabled;
  return disabled ? '#F0F1F3' : '#8990a3';
}, function (_ref12) {
  var disabled = _ref12.disabled,
      theme = _ref12.theme;
  return disabled ? null : theme.brand.primary;
}, function (_ref13) {
  var disabled = _ref13.disabled,
      theme = _ref13.theme;
  return disabled ? null : theme.brand.primary;
}, function (_ref14) {
  var disabled = _ref14.disabled;
  return disabled ? null : 'white';
});

var Input = _styledComponents.default.input.withConfig({
  displayName: "Input"
})(["flex:1 0 auto;min-width:0;width:0;border:2px solid #f0f1f3;text-align:center;font-family:", ";font-size:1.8rem;line-height:120%;letter-spacing:0.01em;color:#222;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.font;
});

RoomInput.defaultProps = {
  minValue: 0
};
RoomInput.propTypes = {
  /** Pass an icon as an element to display it on the left side of the element. (If empty, content takes full width) */
  icon: _propTypes.element,

  /** Label to be displayed above the input. */
  label: _propTypes.string.isRequired,

  /** Info to be shown in the tooltip. (If left empty, tooltip will not be displayed) */
  info: _propTypes.string,

  /** The minimum value the input can have. */
  minValue: _propTypes.number,

  /** The maximum value the input can have. */
  maxValue: _propTypes.number,

  /** The value is returned within this function. */
  onInputChange: _propTypes.func.isRequired,

  /** Extra classNames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object,

  /** Value to change the component value so that it can be updated */
  value: _propTypes.number
};
var _default = RoomInput;
exports.default = _default;